<template>
	<section>
	  <ul class="my_list">
	  		<li v-for='(n,index) in 10' :id="n" :foisSix="foisSix" :key="index">{{ n }}</li>
    </ul>
	</section>
    
</template>

<script>
	import ProviderResult from './ProviderResult.vue'
	export default {
		data(){
			return{

			}
		},
		props:['info'],
		methods:{
		  foisSix(value){
		  	return value * 6;
		  }
		},
    	 components : {
    		'app-provider-result' : ProviderResult,
		}
	}
</script>

<style lang="scss"></style>


// WEBPACK FOOTER //
// src/components/Cheap.vue